import { Center, Box, Button, Text } from '@mantine/core';
import { BiXCircle } from 'react-icons/bi';
import { ContextModalProps } from '@mantine/modals';

interface ContextErrorModalProps extends ContextModalProps {
  innerProps: {
    modalBody: string;
  };
}

const ContextErrorModal = ({ context, id, innerProps }: ContextErrorModalProps) => (
  <Center
    style={{
      flexDirection: 'column',
      margin: '1rem'
    }}
  >
    <BiXCircle size="56" color="#ff8787" />

    <Box style={{ textAlign: 'center' }} mt="1rem">
      <Text>{innerProps.modalBody}</Text>
    </Box>

    <Button w="100%" my="1rem" color="red" tt="uppercase" onClick={() => context.closeModal(id)}>
      Ok
    </Button>
  </Center>
);

export default ContextErrorModal;
